export default "__VITE_ASSET__ad3bb9cf__"